











































import Vue from 'vue'

const papa = require('papaparse')

interface Row {
  [key: string]: number | string
}

interface Field {
  key: string
  label: string
  // eslint-disable-next-line
  thStyle: any
  tdClass: string
}

export default Vue.extend({
  data() {
    return {
      show: false,
      file: undefined as File | undefined,
      fileLoaded: false,
      data: [] as Row[],
      fields: [] as (string | Field)[],
    }
  },

  methods: {
    showDialog() {
      this.show = true
    },

    clearFiles() {
      this.fields = []
      this.data = []
      this.file = undefined
    },

    onInputChanged() {
      if (this.file) {
        this.data = []
        this.fileLoaded = false
        const reader = new FileReader()
        reader.readAsText(this.file, 'UTF-8')

        // eslint-disable-next-line
        reader.onload = (evt: any) => {
          const { data } = papa.parse(evt.target.result, {
            skipEmptyLines: true,
          })

          if (data.length < 1) {
            return
          }

          this.fields = [
            {
              key: '#',
              label: '',
              thStyle: { width: '40px', textAlign: 'center' },
              tdClass: 'text-center bg-secondary text-white',
            },
          ]
          this.fields.push(...data[0])

          for (let rowIndex = 1; rowIndex < data.length - 1; rowIndex++) {
            const row = {} as Row
            for (let colIndex = 1; colIndex < this.fields.length; colIndex++) {
              const field = this.fields[colIndex]
              console.log(field)
              if (typeof field == 'string') {
                row[field] = data[rowIndex][colIndex - 1]
              }
            }

            console.log(row)
            this.data.push(row)
          }

          this.fileLoaded = true
        }
        reader.onerror = () => {
          this.$emit('failed')
        }
      }
    },

    onOKClick() {
      this.$emit('ok', this.data)
    },
  },
})
